import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISepetModal_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISepetModal_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetKaynakMusteriCesit: any[];
  GetKaynakMusteriCesit_dummy: any[];
  GetStokisYapilandir: any[];
  GetStokisYapilandir_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  YapkodBulKaynak: any[];
  YapkodBulKaynak_dummy: any[];
  YapKodKontrol: any[];
  YapKodKontrol_dummy: any[];
  SiparisSepetInsert: number;
  SiparisSepetInsert_dummy: number;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  Notify: boolean;
  Notify_dummy: boolean;
  TeklifSepetiInsert: number;
  TeklifSepetiInsert_dummy: number;
}

export class SepetModal_ScreenBase extends React.PureComponent<
  ISepetModal_ScreenProps,
  any
> {
  sepetmodal_340651_value_kuikaAutoCompleteRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 64155,
          PropertyName: "label",
          Value: "SAVE",
          TagName: "Button1_label",
        },
        {
          Id: 173795,
          PropertyName: "value",
          Value: "ADD TO CART",
          TagName: "Label17_0_value",
        },
        {
          Id: 970625,
          PropertyName: "value",
          Value: "YOU CAN ADD TO CART WITH CHOOSING BRAND AND QUANTITY ",
          TagName: "Label20_value",
        },
        {
          Id: 419427,
          PropertyName: "value",
          Value: "BRAND",
          TagName: "Label3_value",
        },
        {
          Id: 380545,
          PropertyName: "value",
          Value: "AMOUNT",
          TagName: "Label2_value",
        },
        {
          Id: 29561435,
          PropertyName: "ea063887-f63a-1e59-5d26-2f87ea7866f9_notify",
          Value: "PRODUCT ADDED TO YOUR CART",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 30186491,
          PropertyName: "749a4704-faf8-ab66-efe6-8b00e71eaa90_notify",
          Value: "BRAND NOT FOUND PLEASE CONTACT WITH YOUR REPRESENTATIVE",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 53238929,
          PropertyName: "e41f7164-e01c-f00b-facc-8ab3679e473a_notify",
          Value: "PRODUCT OFFER ADDED TO YOUR CART",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 30680556,
          PropertyName: "af716684-6237-225f-f0ca-e28fe11ca7a5_notify",
          Value: "BRAND NOT FOUND PLEASE CONTACT WITH YOUR REPRESENTATIVE",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 10858886,
          PropertyName: "b965e2a1-ab9b-8a87-9663-b336ce0c017f_notify",
          Value: "PRODUCT ADDED TO YOUR CART",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 61931615,
          PropertyName: "f06c6905-af27-7d5e-1a3b-8a80418f91bf_notify",
          Value: "PRODUCT OFFER ADDED TO YOUR CART",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 64155,
          PropertyName: "label",
          Value: "Guardar",
          TagName: "Button1_label",
        },
        {
          Id: 173795,
          PropertyName: "value",
          Value: "Añadir al carrito",
          TagName: "Label17_0_value",
        },
        {
          Id: 970625,
          PropertyName: "value",
          Value: "Añadir al carrito seleccionando la marca y la cantidad.",
          TagName: "Label20_value",
        },
        {
          Id: 419427,
          PropertyName: "value",
          Value: "Marca",
          TagName: "Label3_value",
        },
        {
          Id: 380545,
          PropertyName: "value",
          Value: "Cantidad",
          TagName: "Label2_value",
        },
        {
          Id: 4746454,
          PropertyName: "ea063887-f63a-1e59-5d26-2f87ea7866f9_notify",
          Value: "El producto se ha añadido al carrito de la compra.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 81869038,
          PropertyName: "749a4704-faf8-ab66-efe6-8b00e71eaa90_notify",
          Value:
            "No se ha encontrado la marca. Ponte en contacto con tu representante de atención al cliente.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 86981060,
          PropertyName: "e41f7164-e01c-f00b-facc-8ab3679e473a_notify",
          Value: "El producto se ha añadido a la carrito de la compra.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 76414613,
          PropertyName: "af716684-6237-225f-f0ca-e28fe11ca7a5_notify",
          Value:
            "No se ha encontrado la marca. Ponte en contacto con tu representante de atención al cliente.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 46059390,
          PropertyName: "b965e2a1-ab9b-8a87-9663-b336ce0c017f_notify",
          Value: "El producto se ha añadido al carrito de la compra.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 61935789,
          PropertyName: "f06c6905-af27-7d5e-1a3b-8a80418f91bf_notify",
          Value: "El producto se ha añadido a la carrito de la compra.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 64155,
          PropertyName: "label",
          Value: "Enregistrer",
          TagName: "Button1_label",
        },
        {
          Id: 173795,
          PropertyName: "value",
          Value: "Ajouter au panier",
          TagName: "Label17_0_value",
        },
        {
          Id: 970625,
          PropertyName: "value",
          Value:
            "Vous pouvez ajouter au panier en sélectionnant la marque et la quantité",
          TagName: "Label20_value",
        },
        {
          Id: 419427,
          PropertyName: "value",
          Value: "Marque",
          TagName: "Label3_value",
        },
        {
          Id: 380545,
          PropertyName: "value",
          Value: "Quantité",
          TagName: "Label2_value",
        },
        {
          Id: 37233179,
          PropertyName: "ea063887-f63a-1e59-5d26-2f87ea7866f9_notify",
          Value: "Produit ajouté au panier de commande",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 59532477,
          PropertyName: "749a4704-faf8-ab66-efe6-8b00e71eaa90_notify",
          Value:
            "Marque introuvable. Veuillez contacter votre représentant commercial",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 9939154,
          PropertyName: "e41f7164-e01c-f00b-facc-8ab3679e473a_notify",
          Value: "Produit ajouté au panier d'offre",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 64473263,
          PropertyName: "af716684-6237-225f-f0ca-e28fe11ca7a5_notify",
          Value:
            "Marque introuvable. Veuillez contacter votre représentant commercial",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 54892845,
          PropertyName: "b965e2a1-ab9b-8a87-9663-b336ce0c017f_notify",
          Value: "Produit ajouté au panier de commande",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 71274190,
          PropertyName: "f06c6905-af27-7d5e-1a3b-8a80418f91bf_notify",
          Value: "Produit ajouté au panier d'offre",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "0104fb6a-2a78-4ce6-9478-acf95189cfdb",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 173795, PropertyName: "value", Value: "Sepete Ekle" },
        {
          Id: 970625,
          PropertyName: "value",
          Value: "Marka Ve Miktar Seçerek Sepete Ekleyebilirsiniz",
        },
        { Id: 419427, PropertyName: "value", Value: "Marka" },
        { Id: 380545, PropertyName: "value", Value: "Miktar" },
        { Id: 47352, PropertyName: "value", Value: "Kalem Not" },
        { Id: 64155, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.sepetmodal_340651_value_kuikaAutoCompleteRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetKaynakMusteriCesit: [],
      GetStokisYapilandir: [],
      GoBack: "",
      IfThenElse: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("sepetmodal", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.SepetModalPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("sepetmodal", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("sepetmodal", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.SepetModalPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      sepetmodal_340651_value:
        this.state.GetKaynakMusteriCesit?.at?.(0)?.cesit ?? undefined,
      sepetmodal_214165_value: 1,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  SepetModalPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      cariKod_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      STOK_KODU_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SepetModal/SepetModalPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetKaynakMusteriCesit = result?.data.getKaynakMusteriCesit;

    formVars.sepetmodal_340651_value =
      stateVars.GetKaynakMusteriCesit !== undefined
        ? stateVars.GetKaynakMusteriCesit?.length > 0
          ? stateVars.GetKaynakMusteriCesit[0].cesit
          : null
        : this.state.GetKaynakMusteriCesit?.length > 0
        ? this.state.GetKaynakMusteriCesit[0].cesit
        : null;
    formVars.sepetmodal_340651_options = stateVars.GetKaynakMusteriCesit;
    stateVars.GetStokisYapilandir = result?.data.getStokisYapilandir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SepetModalPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SepetModalPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.sepetmodal_340651_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetKaynakMusteriCesit !== undefined
        ? stateVars.GetKaynakMusteriCesit?.length > 0
          ? stateVars.GetKaynakMusteriCesit[0].cesit
          : null
        : this.state.GetKaynakMusteriCesit?.length > 0
        ? this.state.GetKaynakMusteriCesit[0].cesit
        : null
    );

    formVars.sepetmodal_340651_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetKaynakMusteriCesit !== undefined
        ? stateVars.GetKaynakMusteriCesit?.length > 0
          ? stateVars.GetKaynakMusteriCesit[0].cesit
          : null
        : this.state.GetKaynakMusteriCesit?.length > 0
        ? this.state.GetKaynakMusteriCesit[0].cesit
        : null
    );

    stateVars.dataSource_340651 =
      stateVars.GetKaynakMusteriCesit ?? this.state.GetKaynakMusteriCesit;
    stateVars.dataSource_340651 =
      stateVars.GetKaynakMusteriCesit ?? this.state.GetKaynakMusteriCesit;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  SepetModalComponent_713884_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SepetModalComponent_64155_onClick_if01_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SepetModalComponent_64155_onClick_if0f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "sepetmodal_340651_value",
          "value",
          "GetKaynakMusteriCesit",
          "cesit",
          ""
        ),
        null
      ),
      message: "Bu Alan Boş Bırakılamaz",
      formName: "sepetmodal_340651_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      cariKod_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      stokKod_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      MusteriKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_340651_value",
            "value",
            "GetKaynakMusteriCesit",
            "cesit",
            "cesit"
          )
        ),
        "string"
      ),
      YapKod_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YapkodBulKaynak !== undefined
            ? stateVars.YapkodBulKaynak?.length > 0
              ? stateVars.YapkodBulKaynak[0].yapKod
              : null
            : this.state.YapkodBulKaynak?.length > 0
            ? this.state.YapkodBulKaynak[0].yapKod
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SepetModal/SepetModalComponent_64155_onClick_if0f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YapkodBulKaynak = result?.data.yapkodBulKaynak;
    stateVars.YapKodKontrol = result?.data.yapKodKontrol;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.SepetModalComponent_64155_onClick_if0f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SepetModalComponent_64155_onClick_if0f1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.SepetModalComponent_64155_onClick_if0f1f11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SepetModalComponent_64155_onClick_if0f1f1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "sepetmodal_340651_value",
          "value",
          "GetKaynakMusteriCesit",
          "cesit",
          ""
        ),
        null
      ),
      message: "Bu Alan Boş Bırakılamaz",
      formName: "sepetmodal_340651_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Miktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_214165_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      BirimFiat_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BirimFiyat ??
          this.props.screenInputs.birimfiyat,
        "number"
      ),
      KullaniciID_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KulID ?? this.props.screenInputs.kulid,
        "number"
      ),
      StokKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      MusteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_340651_value",
            "value",
            "GetKaynakMusteriCesit",
            "cesit",
            "cesit"
          )
        ),
        "string"
      ),
      PlasiyerMi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.PlasiyerMi ??
          this.props.screenInputs.plasiyermi,
        "boolean"
      ),
      KdvOrani_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KdvOrani ?? this.props.screenInputs.kdvorani,
        "number"
      ),
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      StokAdi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokAdi ?? this.props.screenInputs.stokadi,
        "string"
      ),
      ExcelKod_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ExcelNot1_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ExcelNot2_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      KalemNot_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_521187_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SepetModal/SepetModalComponent_64155_onClick_if0f1f1f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SiparisSepetInsert = result?.data.siparisSepetInsert;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_if0f1f1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "sepetmodal_340651_value",
          "value",
          "GetKaynakMusteriCesit",
          "cesit",
          ""
        ),
        null
      ),
      message: "Bu Alan Boş Bırakılamaz",
      formName: "sepetmodal_340651_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Miktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_214165_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      BirimFiat_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BirimFiyat ??
          this.props.screenInputs.birimfiyat,
        "number"
      ),
      KullaniciID_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KulID ?? this.props.screenInputs.kulid,
        "number"
      ),
      StokKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      MusteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_340651_value",
            "value",
            "GetKaynakMusteriCesit",
            "cesit",
            "cesit"
          )
        ),
        "string"
      ),
      PlasiyerMi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.PlasiyerMi ??
          this.props.screenInputs.plasiyermi,
        "boolean"
      ),
      KdvOrani_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      StokAdi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokAdi ?? this.props.screenInputs.stokadi,
        "string"
      ),
      ExcelKod_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ExcelNot1_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ExcelNot2_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      KalemNot_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_521187_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SepetModal/SepetModalComponent_64155_onClick_if0f1f1e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SiparisSepetInsert = result?.data.siparisSepetInsert;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_if0f1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.isYurtici ?? this.props.screenInputs.isyurtici,
        true
      )
    ) {
      isErrorOccurred =
        await this.SepetModalComponent_64155_onClick_if0f1f1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.SepetModalComponent_64155_onClick_if0f1f1e1();
      if (isErrorOccurred) return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "ea063887_f63a_1e59_5d26_2f87ea7866f9_notify",
        this.defaultML,
        "Ürün Sipariş Sepetine Eklendi"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_if0f1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "749a4704_faf8_ab66_efe6_8b00e71eaa90_notify",
        this.defaultML,
        "Marka Bulunamadı Lütfen Müşteri Temsilcinizle İletişime Geçin"
      ),
      ReactSystemFunctions.convertToTypeByName("danger", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_if0f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.YapKodKontrol !== undefined
            ? stateVars.YapKodKontrol?.length > 0
              ? stateVars.YapKodKontrol[0].yapkod
              : null
            : this.state.YapKodKontrol?.length > 0
            ? this.state.YapKodKontrol[0].yapkod
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.SepetModalComponent_64155_onClick_if0f1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.SepetModalComponent_64155_onClick_if0f1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_if0e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "sepetmodal_340651_value",
          "value",
          "GetKaynakMusteriCesit",
          "cesit",
          ""
        ),
        null
      ),
      message: "Bu Alan Boş Bırakılamaz",
      formName: "sepetmodal_340651_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      cariKod_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      stokKod_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      MusteriKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_340651_value",
            "value",
            "GetKaynakMusteriCesit",
            "cesit",
            "cesit"
          )
        ),
        "string"
      ),
      YapKod_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YapKodKontrol !== undefined
            ? stateVars.YapKodKontrol?.length > 0
              ? stateVars.YapKodKontrol[0].yapkod
              : null
            : this.state.YapKodKontrol?.length > 0
            ? this.state.YapKodKontrol[0].yapkod
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SepetModal/SepetModalComponent_64155_onClick_if0e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YapkodBulKaynak = result?.data.yapkodBulKaynak;
    stateVars.YapKodKontrol = result?.data.yapKodKontrol;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.SepetModalComponent_64155_onClick_if0e11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SepetModalComponent_64155_onClick_if0e1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.SepetModalComponent_64155_onClick_if0e1f11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SepetModalComponent_64155_onClick_if0e1f1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "sepetmodal_340651_value",
          "value",
          "GetKaynakMusteriCesit",
          "cesit",
          ""
        ),
        null
      ),
      message: "Bu Alan Boş Bırakılamaz",
      formName: "sepetmodal_340651_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BirimFiyat_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BirimFiyat ??
          this.props.screenInputs.birimfiyat,
        "number"
      ),
      KullaniciID_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KulID ?? this.props.screenInputs.kulid,
        "number"
      ),
      StokKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      MusteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_340651_value",
            "value",
            "GetKaynakMusteriCesit",
            "cesit",
            "cesit"
          )
        ),
        "string"
      ),
      Miktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_214165_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PlasiyerMi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.PlasiyerMi ??
          this.props.screenInputs.plasiyermi,
        "boolean"
      ),
      KdvOrani_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KdvOrani ?? this.props.screenInputs.kdvorani,
        "number"
      ),
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      StokAdi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokAdi ?? this.props.screenInputs.stokadi,
        "string"
      ),
      ExcelKod_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ExcelNot1_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ExcelNot2_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SepetModal/SepetModalComponent_64155_onClick_if0e1f1f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TeklifSepetiInsert = result?.data.teklifSepetiInsert;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_if0e1f1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "sepetmodal_340651_value",
          "value",
          "GetKaynakMusteriCesit",
          "cesit",
          ""
        ),
        null
      ),
      message: "Bu Alan Boş Bırakılamaz",
      formName: "sepetmodal_340651_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BirimFiyat_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BirimFiyat ??
          this.props.screenInputs.birimfiyat,
        "number"
      ),
      KullaniciID_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KulID ?? this.props.screenInputs.kulid,
        "number"
      ),
      StokKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      MusteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_340651_value",
            "value",
            "GetKaynakMusteriCesit",
            "cesit",
            "cesit"
          )
        ),
        "string"
      ),
      Miktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_214165_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PlasiyerMi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.PlasiyerMi ??
          this.props.screenInputs.plasiyermi,
        "boolean"
      ),
      KdvOrani_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      StokAdi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokAdi ?? this.props.screenInputs.stokadi,
        "string"
      ),
      ExcelKod_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ExcelNot1_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ExcelNot2_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SepetModal/SepetModalComponent_64155_onClick_if0e1f1e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TeklifSepetiInsert = result?.data.teklifSepetiInsert;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_if0e1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.isYurtici ?? this.props.screenInputs.isyurtici,
        true
      )
    ) {
      isErrorOccurred =
        await this.SepetModalComponent_64155_onClick_if0e1f1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.SepetModalComponent_64155_onClick_if0e1f1e1();
      if (isErrorOccurred) return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "e41f7164_e01c_f00b_facc_8ab3679e473a_notify",
        this.defaultML,
        "Ürün Teklif Sepetine Eklendi"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_if0e1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "af716684_6237_225f_f0ca_e28fe11ca7a5_notify",
        this.defaultML,
        "Marka Bulunamadı Lütfen Müşteri Temsilcinizle İletişime Geçin"
      ),
      ReactSystemFunctions.convertToTypeByName("danger", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_if0e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.YapKodKontrol !== undefined
            ? stateVars.YapKodKontrol?.length > 0
              ? stateVars.YapKodKontrol[0].yapkod
              : null
            : this.state.YapKodKontrol?.length > 0
            ? this.state.YapKodKontrol[0].yapkod
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.SepetModalComponent_64155_onClick_if0e1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.SepetModalComponent_64155_onClick_if0e1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_if01_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.isSiparis ?? this.props.screenInputs.issiparis,
        true
      )
    ) {
      isErrorOccurred = await this.SepetModalComponent_64155_onClick_if0f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.SepetModalComponent_64155_onClick_if0e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.SepetModalComponent_64155_onClick_else01_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SepetModalComponent_64155_onClick_else0f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.SepetModalComponent_64155_onClick_else0f11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SepetModalComponent_64155_onClick_else0f1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "sepetmodal_340651_value",
          "value",
          "GetKaynakMusteriCesit",
          "cesit",
          ""
        ),
        null
      ),
      message: "Bu Alan Boş Bırakılamaz",
      formName: "sepetmodal_340651_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Miktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_214165_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      BirimFiat_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BirimFiyat ??
          this.props.screenInputs.birimfiyat,
        "number"
      ),
      KullaniciID_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KulID ?? this.props.screenInputs.kulid,
        "number"
      ),
      StokKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      MusteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_340651_value",
            "value",
            "GetKaynakMusteriCesit",
            "cesit",
            "cesit"
          )
        ),
        "string"
      ),
      PlasiyerMi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.PlasiyerMi ??
          this.props.screenInputs.plasiyermi,
        "boolean"
      ),
      KdvOrani_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KdvOrani ?? this.props.screenInputs.kdvorani,
        "number"
      ),
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      StokAdi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokAdi ?? this.props.screenInputs.stokadi,
        "string"
      ),
      ExcelKod_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ExcelNot1_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ExcelNot2_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      KalemNot_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_521187_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SepetModal/SepetModalComponent_64155_onClick_else0f1f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SiparisSepetInsert = result?.data.siparisSepetInsert;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_else0f1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "sepetmodal_340651_value",
          "value",
          "GetKaynakMusteriCesit",
          "cesit",
          ""
        ),
        null
      ),
      message: "Bu Alan Boş Bırakılamaz",
      formName: "sepetmodal_340651_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Miktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_214165_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      BirimFiat_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BirimFiyat ??
          this.props.screenInputs.birimfiyat,
        "number"
      ),
      KullaniciID_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KulID ?? this.props.screenInputs.kulid,
        "number"
      ),
      StokKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      MusteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_340651_value",
            "value",
            "GetKaynakMusteriCesit",
            "cesit",
            "cesit"
          )
        ),
        "string"
      ),
      PlasiyerMi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.PlasiyerMi ??
          this.props.screenInputs.plasiyermi,
        "boolean"
      ),
      KdvOrani_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      StokAdi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokAdi ?? this.props.screenInputs.stokadi,
        "string"
      ),
      ExcelKod_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ExcelNot1_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ExcelNot2_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      KalemNot_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_521187_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SepetModal/SepetModalComponent_64155_onClick_else0f1e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SiparisSepetInsert = result?.data.siparisSepetInsert;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_else0f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.isYurtici ?? this.props.screenInputs.isyurtici,
        true
      )
    ) {
      isErrorOccurred =
        await this.SepetModalComponent_64155_onClick_else0f1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.SepetModalComponent_64155_onClick_else0f1e1();
      if (isErrorOccurred) return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "b965e2a1_ab9b_8a87_9663_b336ce0c017f_notify",
        this.defaultML,
        "Ürün Sipariş Sepetine Eklendi"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_else0e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.SepetModalComponent_64155_onClick_else0e11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SepetModalComponent_64155_onClick_else0e1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "sepetmodal_340651_value",
          "value",
          "GetKaynakMusteriCesit",
          "cesit",
          ""
        ),
        null
      ),
      message: "Bu Alan Boş Bırakılamaz",
      formName: "sepetmodal_340651_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BirimFiyat_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BirimFiyat ??
          this.props.screenInputs.birimfiyat,
        "number"
      ),
      KullaniciID_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KulID ?? this.props.screenInputs.kulid,
        "number"
      ),
      StokKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      MusteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_340651_value",
            "value",
            "GetKaynakMusteriCesit",
            "cesit",
            "cesit"
          )
        ),
        "string"
      ),
      Miktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_214165_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PlasiyerMi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.PlasiyerMi ??
          this.props.screenInputs.plasiyermi,
        "boolean"
      ),
      KdvOrani_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KdvOrani ?? this.props.screenInputs.kdvorani,
        "number"
      ),
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      StokAdi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokAdi ?? this.props.screenInputs.stokadi,
        "string"
      ),
      ExcelKod_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ExcelNot1_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ExcelNot2_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SepetModal/SepetModalComponent_64155_onClick_else0e1f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TeklifSepetiInsert = result?.data.teklifSepetiInsert;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_else0e1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "sepetmodal_340651_value",
          "value",
          "GetKaynakMusteriCesit",
          "cesit",
          ""
        ),
        null
      ),
      message: "Bu Alan Boş Bırakılamaz",
      formName: "sepetmodal_340651_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BirimFiyat_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BirimFiyat ??
          this.props.screenInputs.birimfiyat,
        "number"
      ),
      KullaniciID_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KulID ?? this.props.screenInputs.kulid,
        "number"
      ),
      StokKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokKodu ?? this.props.screenInputs.stokkodu,
        "string"
      ),
      MusteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_340651_value",
            "value",
            "GetKaynakMusteriCesit",
            "cesit",
            "cesit"
          )
        ),
        "string"
      ),
      Miktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "sepetmodal_214165_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PlasiyerMi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.PlasiyerMi ??
          this.props.screenInputs.plasiyermi,
        "boolean"
      ),
      KdvOrani_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      StokAdi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StokAdi ?? this.props.screenInputs.stokadi,
        "string"
      ),
      ExcelKod_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ExcelNot1_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ExcelNot2_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SepetModal/SepetModalComponent_64155_onClick_else0e1e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TeklifSepetiInsert = result?.data.teklifSepetiInsert;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_else0e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.isYurtici ?? this.props.screenInputs.isyurtici,
        true
      )
    ) {
      isErrorOccurred =
        await this.SepetModalComponent_64155_onClick_else0e1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.SepetModalComponent_64155_onClick_else0e1e1();
      if (isErrorOccurred) return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "f06c6905_af27_7d5e_1a3b_8a80418f91bf_notify",
        this.defaultML,
        "Ürün Teklif Sepetine Eklendi"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick_else01_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.isSiparis ?? this.props.screenInputs.issiparis,
        true
      )
    ) {
      isErrorOccurred = await this.SepetModalComponent_64155_onClick_else0f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.SepetModalComponent_64155_onClick_else0e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SepetModalComponent_64155_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokisYapilandir !== undefined
            ? stateVars.GetStokisYapilandir?.length > 0
              ? stateVars.GetStokisYapilandir[0].isYapilandir
              : null
            : this.state.GetStokisYapilandir?.length > 0
            ? this.state.GetStokisYapilandir[0].isYapilandir
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.SepetModalComponent_64155_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.SepetModalComponent_64155_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.SepetModalPageInit();
    }
  }
}
